<div class="container">
    <div id="wrapper">
        <div class="content-wrapper">
            <div class="error pageLevel" aria-hidden="false" role="alert">
                <p tabindex="-1" [innerHTML]="message"></p>
            </div>

        </div>
    </div>



</div>